import Vue from "vue";
import Vuetify from "vuetify/lib";
import "@mdi/font/css/materialdesignicons.css";

Vue.use(Vuetify, {
  iconfont: "mdi",
});

import fr from "vuetify/es5/locale/fr";
import en from "vuetify/es5/locale/en";

export default new Vuetify({
  lang: {
    locales: { fr, en },
    current: "fr",
  },
  theme: {
    dark: true,
    default: "dark",
    themes: {
      light: {
        primary: "#1976D2",
        secondary: "#424242",
        accent: "#F29017",
        error: "#FF5252",
        info: "#2196F3",
        success: "#9AC430",
        warning: "#FB8C00",
      },
      dark: {
        primary: "#2196F3",
        secondary: "#424242",
        accent: "#F29017",
        error: "#FF5252",
        info: "#2196F3",
        success: "#9AC430",
        warning: "#FB8C00",
      },
    },
  },
});
